// export { default } from './ChatForm';
import ChatForm from './ChatForm';

export default ChatForm;

